var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-easy-lightbox',{attrs:{"imgs":_vm.image,"index":_vm.index,"visible":_vm.visible,"escDisabled":"","moveDisabled":""},on:{"hide":function($event){_vm.visible = false}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }